import { Avatar, AvatarImage } from "@workspace/ui/components/avatar";
import { cn } from "@workspace/ui/lib/utils";

export type TestimonialAuthor = {
  name: string;
  handle: string;
  avatar: string;
};

export type TestimonialCardProps = {
  author: TestimonialAuthor;
  text: string;
  href?: string;
  className?: string;
};

export function TestimonialCard({
  author,
  text,
  href,
  className,
}: TestimonialCardProps) {
  const Card = href ? "a" : "div";

  return (
    <Card
      {...(href ? { href } : {})}
      className={cn(
        "flex flex-col rounded-2xl border border-border/50",
        "bg-card/50 backdrop-blur-sm",
        "p-6 text-start",
        "hover:border-border hover:bg-card/80",
        "min-h-[200px] max-w-[350px]",
        "transition-all duration-300",
        className
      )}
    >
      <p className="mb-6 grow font-light text-muted-foreground text-sm leading-relaxed sm:text-base">
        {text}
      </p>
      <div className="flex items-center gap-3">
        <Avatar className="h-10 w-10">
          <AvatarImage alt={author.name} src={author.avatar} />
        </Avatar>
        <div className="flex flex-col">
          <h3 className="font-medium text-sm">{author.name}</h3>
          <p className="text-muted-foreground text-xs">{author.handle}</p>
        </div>
      </div>
    </Card>
  );
}
